import { render, staticRenderFns } from "./HandiSolid.vue?vue&type=template&id=0090a3ac&"
import script from "./HandiSolid.vue?vue&type=script&lang=ts&"
export * from "./HandiSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports